import React from 'react';
import { useState, createContext } from 'react';
export const AuthContext = createContext(null)

 export default function context({children})
 {
const [user, setUser] = useState(null)
return (
    <AuthContext.Provider value={{user, setUser}}>
{children}
    </AuthContext.Provider>
)
}